<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@/mixins/shared/formInput";
import Date from '@/pages/components/form/input-only/date.vue';
import dateProps from '@/mixins/shared/dateProps'

export default {
	mixins: [formInput,dateProps],
	components: {FormGroup, Date},
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		}
	}
}
</script>

<template>
	<FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
		<template #label v-if="$slots.label">
			<slot name="label" />
		</template>

		<template #label v-if="!$slots.label">
			{{ label }}
		</template>

        <Date
            v-bind="$attrs"
			ref="date"
            :form="form"
            :name="name"
            :id="renderedId"
            :min="min"
            :max="max"
            :model-value="modelValue"
            @update:modelValue="changeModelValueTo"
		>
			<template #addonbefore v-if="$slots.addonbefore"><slot name="addonbefore" /></template>
			<template #addonafter>
				<i role="button" class="bi bi-calendar" @click="this.$refs.date.$refs.input.click()"></i>
			</template>
			<template #descriptionbottom v-if="$slots.descriptionbottom"><slot name="descriptionbottom" /></template>
		</Date>
	</FormGroup>
</template>